module.exports = __webpack_public_path__ + "assets/img/ic-coin-ani.868ba296.png";